/*global define*/
/*jshint devel:true*/
/**
 * Base Settings config view
 */
define(
	'BaseSettingsView',[
		"BaseView",
		"jquery",
		'underscore'
	],
	function (BaseView, $, _) {
		"use strict";

		var ParentClass = BaseView,
			parentClassPrototype = ParentClass.prototype;

		/**
		 * @class
		 * @name BaseSettingsView
		 * @extends BaseView
		 */
		return ParentClass.extend(
			/**
			 * @lends BaseSettingsView.prototype
			 */
			{
				//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
				// MEMBERS
				//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
				/**
				 * Name of the current class. Used to build debug messages.
				 * @type {String}
				 */
				className: 'BaseSettingsView',
				/**
				 * List of dom selectors to use with jQuery.
				 * The jQuery selector range is limited to the view root element (this.el)
				 * They'll only be processed by the render method
				 * @example
				 * {
				 *  buttons: 'button',
				 *  formLinks: 'form a[href]'
				 * }
				 * DOM elements found after processing these selectors are stored in this.domElements.
				 * @type {Object} A hash of jQuery selectors
				 */
				domSelectors: {
					settingsChangedMessage: '.saveChangesReminderMsg',
					settingsSavedMessage: '.settingsSavedMessage',
					serverErrorMessages: '.serverErrorMessages',
					userInputs: ':input'
				},
				/**
				 * See documentation in BaseView class
				 *
				 */
				domElements: null,
				
				//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
				// METHODS
				//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//				/**
//				 * Init the view
//				 * @constructs
//				 * @param {Object} options
//				 */

				showSaveSettingsNotification: function () {
					var self = this;
					self.domElements.settingsChangedMessage.fadeIn();
					return self;
				},

				hideSaveSettingsNotification: function () {
					var self = this;
					self.domElements.settingsChangedMessage.fadeOut();
					return self;
				},

				showSettingsSavedNotification: function () {
					var self = this;
					self.domElements.settingsSavedMessage.fadeIn();
					return self;
				},

				hideSettingsSavedNotification: function () {
					var self = this;
					self.domElements.settingsSavedMessage.fadeOut();
					return self;
				},

				showErrorMessages: function () {
					var self = this;
					self.domElements.serverErrorMessages.fadeIn();
					return self;
				},

				enableUserInputs: function () {
					var self = this;
					self.domElements.userInputs.prop('disabled', false);
					return self;
				},

				disableUserInputs: function () {
					var self = this;
					self.domElements.userInputs.prop('disabled', true);
					return self;
				}
			}
		);
	}
);
